import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { Autorenew } from '@styled-icons/material'
import { useDrafts } from '@oneblink/apps-react'

import ErrorMessage from 'components/ErrorMessage'
import LoadingSpinner from 'components/LoadingSpinner'
import ErrorModal from 'components/Modals/ErrorModal'
import { H1, P } from 'components/TextComponents'
import DraftsListItem from './DraftsListItem'

import useViewportSizes from 'use-viewport-sizes'
import { useTheme } from 'styled-components'

const DraftsHeaderContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
`
DraftsHeaderContainer.displayName = 'DraftsHeaderContainer'

const SyncDraftsButtonContainer = styled.div`
  margin-left: auto;
  padding-left: 2rem;
`
SyncDraftsButtonContainer.displayName = 'SyncDraftsButtonContainer'

const SyncIcon = styled(Autorenew)`
  height: 1.4rem;
  margin-right: 0.3rem;
`
SyncIcon.displayName = 'SyncIcon'

const spin = keyframes`
  100% {
    transform:rotate(360deg); 
  }
`

const SyncingIcon = styled(Autorenew)`
  height: 1.4rem;
  margin-right: 0.3rem;
  animation: ${spin} 2s linear infinite;
`
SyncingIcon.displayName = 'SyncingIcon'

export default function Drafts() {
  //@ts-expect-error
  const [vpWidth] = useViewportSizes({ throttleTimeout: 1000 })
  const theme = useTheme()

  const {
    drafts,
    isLoading,
    loadError,
    isSyncing,
    syncDrafts,
    syncError,
    clearSyncError,
  } = useDrafts()

  return (
    <div>
      <DraftsHeaderContainer>
        <H1 className="fa-drafts__header">Drafts</H1>
        <SyncDraftsButtonContainer>
          <button
            className="button ob-button is-primary"
            onClick={syncDrafts}
            disabled={isSyncing}
          >
            {isSyncing ? <SyncingIcon /> : <SyncIcon />}
            {vpWidth > theme.screenSizes.phone && 'Sync Drafts'}
          </button>
        </SyncDraftsButtonContainer>
      </DraftsHeaderContainer>
      <div>
        {isLoading ? (
          <LoadingSpinner>Retrieving drafts...</LoadingSpinner>
        ) : loadError ? (
          <ErrorMessage>
            An error has occurred while attempting to load drafts:{' '}
            {loadError?.message}
          </ErrorMessage>
        ) : drafts.length ? (
          <>
            {drafts.map((draft) => (
              <DraftsListItem
                draft={draft}
                key={draft.draftId}
                disabled={isSyncing}
              />
            ))}
          </>
        ) : (
          <P>You have no drafts</P>
        )}

        <ErrorModal error={syncError} onClose={clearSyncError} />
      </div>
    </div>
  )
}
